import base from 'utils/geoFencing.js';

let redirectState = (geoFencedLocation) => {
	if (!geoFencedLocation) {
		return;
	}
	if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
		console.log('GEOFENCING GOING TO', geoFencedLocation);
		return;
	}
	let destination = (/^((https?:)?\/\/)?([^/]+)\/([^/]+)/.exec(geoFencedLocation) || []);
	let destinationHost = destination[3];
	let destinationRegion = destination[4];

	// Try to prevent SOME infinite redirect loops (wouldn't catch a lot of things)
	if (window.location.host !== destinationHost || window.location.pathname.indexOf(`/${destinationRegion}`) === -1) {
		window.location.href = geoFencedLocation;
	}
	return true;
};

export default function geoFencing(getGeo) {
	return base(getGeo, redirectState);
}
